exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-3d3239ad]{outline:none}a[data-v-3d3239ad]:visited{color:initial}", ""]);

// exports
